module.exports = __webpack_public_path__ + "static/media/06-SeedingOpportunities.252da41d.gif";